export function isChaseVehicle(v) {
   if (!v) {
      return false;
   }
   if (v.isChase) {
      return true;
   }
   return String(v.vehicleVIN || '').trim().toLowerCase() === 'chase';
}

export function vehicleName(v, fallback = 'Unspecified Vehicle') {
   if (isChaseVehicle(v)) {
      return 'Chase';
   }
   const label = `${v?.vehicleYear ?? ''} ${v?.vehicleMake ?? ''} ${v?.vehicleModel ?? ''}`.trim();
   return label || fallback;
}
